/**
 * React component that is responsible for rendering a basic CTA section,
 *  i.e. a cta header with centered children.
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React, { useMemo } from 'react';
import Grid from '@material-ui/core/Grid'
import cx from 'classnames'
import CTAHeader, { CTAHeaderPropTypes } from 'components/CTAHeader'
import SectionWrapper, { SectionWrapperPropTypes } from 'components/SectionWrapper'

const BasicSection = ({
  className,
  flipped,
  backgroundColor,
  backgroundImage,
  backgroundImageMobile,
  backgroundVideo,
  alignItems,
  justify,
  children,
  ...props
}) => {
  const Header = useMemo(() => {
    const {
      title, subtitle, tagline, footer, buttons,
    } = props

    return (title || subtitle || tagline || footer || buttons?.length > 0) ? (
      <Grid
        direction="column"
        justify={justify}
        alignItems={alignItems}
        spacing={4}
        container>
        <Grid item xs={10}>
          <CTAHeader
            alignItems={alignItems}
            justify={justify}
            {...props} />
        </Grid>
      </Grid>
    ) : null
  }, [alignItems, justify, props])

  return (
    <SectionWrapper
      className={cx(className, {
        'py-2xl': !className,
      })}
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      backgroundImageMobile={backgroundImageMobile}
      backgroundVideo={backgroundVideo}>
      {(flipped) ? (
        <>
          {children}
          {Header}
        </>
      ) : (
        <>
          {Header}
          {children}
        </>
      )}
    </SectionWrapper>
  )
}

BasicSection.defaultProps = {
  alignItems: 'center',
  justify: 'center',
  flipped: false,
  onPrimaryClick: () => false,
  onSecondaryClick: () => false,
}

BasicSection.propTypes = {
  ...CTAHeaderPropTypes,
  ...SectionWrapperPropTypes,
}

export default BasicSection
